import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar-account',
  templateUrl: './sidebar-account.component.html',
  styleUrls: ['./sidebar-account.component.sass']
})
export class SidebarAccountComponent implements OnInit {
  authenticated$: any;

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authenticated$ = this.authService.getAuthenticatedUser();
  }

  hasScope(scope) {
    return this.authService.hasScope(scope);
  }
}
